// extracted by mini-css-extract-plugin
export default {"glass":"style_glass__P0XzJ","tyre":"style_tyre__MP+l4"};